(function () {
  var LOCALE = (document.documentElement.lang || 'tr').split('-')[0];
  var STORAGE_KEY = 'be_recently_viewed_v1_' + LOCALE;
  var MAX_ITEMS = 10;

  function readItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function trackCurrentProduct() {
    var dataEl = document.querySelector('[data-be-recent-product]');
    if (!dataEl) return;

    try {
      var product = JSON.parse(dataEl.textContent);
      if (!product || !product.id) return;

      var items = readItems().filter(function (item) {
        return String(item.id) !== String(product.id);
      });

      items.unshift(product);
      writeItems(items);
    } catch (error) {
      /* ignore invalid product json */
    }
  }

  function renderRecentlyViewed() {
    var root = document.querySelector('[data-be-recently-viewed]');
    if (!root) return;

    var list = root.querySelector('[data-be-recent-list]');
    var items = readItems();

    var dataEl = document.querySelector('[data-be-recent-product]');
    if (dataEl) {
      try {
        var current = JSON.parse(dataEl.textContent);
        items = items.filter(function (item) {
          return String(item.id) !== String(current.id);
        });
      } catch (error) {
        /* ignore */
      }
    }

    if (!list || !items.length) {
      root.hidden = true;
      return;
    }

    root.hidden = false;
    list.innerHTML = items
      .map(function (item) {
        var image = item.image
          ? '<img src="' + item.image + '" alt="" class="be-recent__img" loading="lazy">'
          : '<span class="be-recent__img be-recent__img--empty"></span>';

        return (
          '<a class="be-recent__card" href="' +
          item.url +
          '">' +
          '<span class="be-recent__media">' +
          image +
          '</span>' +
          '<span class="be-recent__title">' +
          escapeHtml(item.title) +
          '</span>' +
          (item.price ? '<span class="be-recent__price">' + escapeHtml(item.price) + '</span>' : '') +
          '</a>'
        );
      })
      .join('');
  }

  trackCurrentProduct();
  renderRecentlyViewed();
})();
